import { useEffect,useState,useMemo } from "react";
import DataTable from "react-data-table-component";
import { useFetchData } from "../../hooks/useFetchData";
import {
  complaintsColumns,
  complaintsHeaders,
} from "../../utils/columns/complaintColumns";
import { customStyles, splitStringByKeyword } from "../../utils/data/essential";
import UpdateComplaint from "../../Component/complaints/UpdateComplaint";
import moment from "moment";
import { CSVLink } from "react-csv";
import Locations from "../../Component/Locations";
import { Button } from "react-bootstrap";
const Complaints = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [row, setRow] = useState()
  const [keyword, setKeyword] = useState("");
  const [exportData, setExportData] = useState([]);
  const columns = complaintsColumns(setShowEditModal, setRow);
  const user = JSON.parse(localStorage.getItem("user"));
  const [locationId, setLocationId] = useState(user.location_id);
  const [loading, setLoading] = useState(false);
  // Fetch complaints
  const url = `accounts/complaints?locationId=${locationId}`;
  const { data, refetch } = useFetchData(["fetch-complaints"], url, false, user);
  useEffect(() => {
    if (data) setLoading(false)
  }, [data]);
  const filterData = (searchTerm) => {
    if (!searchTerm) {
      return data;
    }
    return data?.filter((dt) => {
      return (
        dt?.phoneNumber.includes(searchTerm) ||
        dt?.info.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.status?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.type?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.datetime?.includes(searchTerm.toLowerCase())
      );
    });
  };
  const filteredData = useMemo(() => filterData(keyword), [data, keyword]);
  const extractData = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.accountId = el.accountId;
      obj.type = el.type.name;
      obj.status = el.status.name;
      obj.phoneNumber = el.phoneNumber;
      obj.details = el.details;
      obj.info = splitStringByKeyword(el.info, "By").before.substring(
        0,
        splitStringByKeyword(el.info, "By").before.length - 2
      );
      obj.operator = splitStringByKeyword(el.info, "By").after;
      obj.date = moment(el.datetime).format("DD/MM/YYYY");
      arr.push(obj);
      obj = {};
    });
    setExportData(arr);
  };
  useEffect(() => {
    extractData(filteredData);
  }, [filteredData]);
  const datafromChildComponent = (data) => {
    setLocationId(data.locationId);
  };
  return (
    <div>
      <div className='d-flex flex-wrap justify-content-center mb-4 mt-3'>
        <h3 className='ml-3'>Complaints</h3>
      </div>
      <Locations sendDataToParent={datafromChildComponent} />
      <div className='d-flex justify-content-center'>
        <Button
          style={{ backgroundColor: "#124db1" }}
          onClick={() => {
            setLoading(true);
            refetch();
          }}
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      {/* <div style={{ backgroundColor: "#dfdfdf", height: 3 }} /> */}
      <div className='d-flex flex-wrap justify-content-center'>
        {data?.length > 0 && (
          <div className='flex-container' style={{ width: "100%" }}>
            <div className='quick-search-container'>
              <input
                type='text'
                className='form-control quick-search ml-2'
                placeholder="Quick search by operator's names,status,phone,type or date(2024-04-23)"
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                style={{
                  bottom: filteredData.length === 0 ? -50 : -80,
                }}
              />
            </div>
          </div>
        )}
      </div>
      {filteredData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={exportData}
            headers={complaintsHeaders}
            filename={`complaints`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={filteredData?.length === 0}
              style={{
                backgroundColor:
                  filteredData?.length === 0 ? "#cbcbcb" : "#124db1",
                color: filteredData?.length === 0 ? "#000" : "",
                cursor: filteredData?.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={filteredData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
      <UpdateComplaint
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        updateData={row}
      />
    </div>
  );
};

export default Complaints;
